/**
 * This multiplatform component can be used to open modal windows that contain an iframe.
  */
(function iframeModalOpener(global) {
  'use strict';

  function openModal(event) {
    // Use currentTarget to scope the search to the container
    const container = event.currentTarget;
    if (!container) {
      return;
    }
    // Find the opener that was actually clicked (or its ancestor)
    const target = event.target.closest('[data-dialog-opener]');
    // Only proceed if the target is inside the container
    if (!target || !container.contains(target)) {
      return;
    }
    const id = target.dataset.dialogOpener;
    if (!id) {
      return;
    }
    const modal = document.getElementById(id);
    if (modal) {
      // if the polyfill exists, we need to register the dialog element.
      if (global.dialogPolyfill) {
        global.dialogPolyfill.registerDialog(modal);
      }

      modal.showModal();
      const iframe = modal.querySelector('iframe');

      if (iframe && !iframe.src) {
        iframe.src = iframe.dataset.src;
        iframe.removeAttribute('data-src');
      }

      // event listener to close the modal.
      // event closeIspModal is added in order to close the Interactive Site Plan modal
      // when the user clicks the Request a Tour button to show the form for Available Lots. Ticket BDXNHS-8316.
      modal.addEventListener('click', (e) => {
        if (e.target === modal || e.target.dataset.closeModalForm !== undefined) {
          modal.close();
        }
      });
    }
  }

  function handleModalInteraction(event) {
    // Check if native support for the dialog element
    if (typeof HTMLDialogElement === 'function') {
      openModal(event);

      // if not, check if require support.
    } else if (typeof define === 'function' && define.amd) {
      require(['dialogPolyfill'], (polyfill) => {
        // store the polyfill in the window.
        global.dialogPolyfill = polyfill;
        openModal(event);
      });

      // if not, load via the loadJs script
    } else {
      const url = document.querySelector('#dialogPolyfillBundle');
      if (url) {
        global.NHS.loadJs(url.value, 'dialogPolyfill', () => {
          openModal(event);
        });
      }
    }
  }

  // Attach only one listener per container, even if multiple openers exist inside
  const containers = new Set();
  const openers = document.querySelectorAll('[data-dialog-opener]');
  openers.forEach((opener) => {
    const container = opener.closest('[data-iframe-modal-launcher-container]');
    if (container && !containers.has(container)) {
      containers.add(container);
      container.addEventListener('click', handleModalInteraction);
    }
  });
}(window));
